// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"ab81c8d4","711":"0dbc7d8b","776":"78f6fe13"}[chunkId] + ".chunk.css";
};